export const SHOW_WARNING_DIALOG = "SHOW_WARNING_DIALOG";
export const HIDE_WARNING_DIALOG = "HIDE_WARNING_DIALOG";

export const showWarningDialog = (message) => ({
  type: SHOW_WARNING_DIALOG,
  payload: { message },
});

export const hideWarningDialog = () => ({
  type: HIDE_WARNING_DIALOG,
});